var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-input-group"},[_c('input',{ref:"input",staticClass:"ai-input ai-input-group__input",attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInputValueChange}}),_c('div',{staticClass:"ai-button ai-input-group__button"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }